import { AllieEllipse, AllieEllipseType } from '../Ellipse';
import { StyledGridContent, StyledText } from './GridContentWidget.styles';

interface GridContentWidgetProps {
  ellipseColor: AllieEllipseType;
  hasBlocked?: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  selected: boolean;
  text: string;
  value: number;
}

export const AllieGridContentWidget: React.FC<GridContentWidgetProps> = ({
  ellipseColor,
  hasBlocked = false,
  onClick,
  selected,
  text,
  value,
}) => (
  <StyledGridContent hasBlocked={hasBlocked} onClick={onClick}>
    <StyledText type="body2" weight={600} selected={selected}>
      {text}
    </StyledText>
    <div style={{ display: 'flex', columnGap: '8px', alignItems: 'center' }}>
      <AllieEllipse allieType={ellipseColor} />
      <StyledText type="h3" weight={600} selected={selected}>
        {value}
      </StyledText>
    </div>
  </StyledGridContent>
);
